import React from 'react';
import { Clock, DollarSign, BarChart2, Package } from 'lucide-react';
import './ProjectCard.css';

const difficultyColor = {
  Beginner: '#00d68f',
  Intermediate: '#ff9900',
  Advanced: '#ff4757',
};

export default function ProjectCard({ project, totalComponents }) {
  if (!project) return null;
  const dColor = difficultyColor[project.difficulty] || '#00e5ff';

  return (
    <div className="project-card animate-in">
      <div className="project-header">
        <div>
          <h2 className="project-title">{project.title}</h2>
          <p className="project-desc">{project.description}</p>
        </div>
        <span className="difficulty-badge" style={{ color: dColor, borderColor: dColor + '44', background: dColor + '11' }}>
          {project.difficulty}
        </span>
      </div>

      <div className="project-stats">
        <div className="stat">
          <DollarSign size={16} className="stat-icon" />
          <div>
            <div className="stat-label mono">Est. Cost</div>
            <div className="stat-value">{project.estimatedCost}</div>
          </div>
        </div>
        <div className="stat-divider" />
        <div className="stat">
          <Clock size={16} className="stat-icon" />
          <div>
            <div className="stat-label mono">Build Time</div>
            <div className="stat-value">{project.estimatedTime}</div>
          </div>
        </div>
        <div className="stat-divider" />
        <div className="stat">
          <Package size={16} className="stat-icon" />
          <div>
            <div className="stat-label mono">Components</div>
            <div className="stat-value">{totalComponents} items</div>
          </div>
        </div>
        <div className="stat-divider" />
        <div className="stat">
          <BarChart2 size={16} className="stat-icon" />
          <div>
            <div className="stat-label mono">Difficulty</div>
            <div className="stat-value" style={{ color: dColor }}>{project.difficulty}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
